import React, { Component } from 'react';
import AllItems from './components/AllItems';
import { Container, Row, Col, Button, Carousel, Navbar, Nav } from 'react-bootstrap'; 
import './App.css';

class App extends Component {
  howSettings(event) {
    event.preventDefault();
  }

  render() {
    return (
      <section> 
        <Container fluid={true} className="top_nav">
          <Container>
            <Navbar expand="lg">
              <Navbar.Brand href="#" ><div  id="shop_logo" /></Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                  <Nav.Link href="">Home</Nav.Link>
                  <Nav.Link href="">Link</Nav.Link>
                </Nav>

                <Button variant="outline-success">Search</Button>

              </Navbar.Collapse>
            </Navbar>
          </Container>
        </Container>
        <Container>
        </Container>
        <Container className="slider" fluid={true}>
          <div className="slider_overlay"></div>
          <Carousel className="carousel">
            <Carousel.Item>
              <img className="d-block w-100" src="img/slider_1.jpg" alt="Third-slide" />
            </Carousel.Item>
            <Carousel.Item>
              <img className="d-block w-100" src="img/slider_2.jpg" alt="Third slide" />
            </Carousel.Item>
            <Carousel.Item>
              <img className="d-block w-100" src="img/slider_3.jpg" alt="Third slide" />
            </Carousel.Item>
          </Carousel>
        </Container>

        <br /><br /><br /><br />

        <Container>
          <Row>
            <Col md={4} >
              <div className="cat_div">
                <div className="cat_overlay"></div>
                <div className="cat_caption">
                  <h3>Shirts</h3>
                  <p>Summer 2019</p>
                </div>
                <img className="responsive_img cat_img" src="img/Cat_img_1.png" alt="cat-" />
                <div className="cat_action">
                  <p>  Shop Now </p>
                </div>
              </div>
            </Col>

            <Col md={4}  >
              <div className="cat_div">
                <div className="cat_overlay"></div>
                <div className="cat_caption">
                  <h3> Jeans </h3>
                  <p> Summer 2019 </p>
                </div>
                <img className="responsive_img cat_img" src="img/Cat_img_2.png" alt="cat-" />
                <div className="cat_action">
                  <p>  Shop Now </p>
                </div>
              </div>
            </Col>

            <Col md={4} >
              <div className="cat_div">
                <div className="cat_overlay"></div>
                <div className="cat_caption">
                  <h3> Accessories </h3>
                  <p> Summer 2019 </p>
                </div>
                <img className="responsive_img cat_img" src="img/Cat_img_3.jpg" alt="cat-imge" />
                <div className="cat_action">
                  <p>  Shop Now </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        <br /><br /><br /><br />

        <Container>

          <AllItems itemsNo={20} ></AllItems>

        </Container>

        <br /><br /><br /><br />
        <div className="footer">
          <p>Copyright © 2019 All rights reserved | This website is made with <span> <img src="img/icon-heart-02.png" alt="like_image" /></span> by <a href="https://www.facebook.com/Mando.h4m" target="_blank" rel="noopener noreferrer">Abdelmenon</a></p>

        </div> 
 
      </section>

    );
  }
}

export default App;
